module.exports = __webpack_public_path__ + "static/media/SBJ-BartMarielle-header.b7d6586c.jpg";